// Test Ids
export const sensitivityLabelTooltipId = 'sensitivityLabelTooltipId';
export const sensitivityButtonId = 'sensitivityButtonId';
export const sensitivityButtonLabelId = 'sensitivityButtonLabelId';
export const sensitivityButtonDividerId = 'sensitivityButtonDividerId';
export const sensitivityTagIconId = 'sensitivityTagIconId';
export const sensitivityTagSmallIconId = 'sensitivityTagSmallIconId';
export const sensitivityTagProtectedIconId = 'sensitivityTagProtectedIconId';
export const sensitivityTagProtectedSmallIconId = 'sensitivityTagProtectedSmallIconId';
export const sensitivityTagUnknownIconId = 'sensitivityTagUnknownIconId';
export const sensitivityTagRequiredIconId = 'sensitivityTagRequiredIconId';
export const justificationChangeButtonId = 'justificationChangeButtonId';
export const justificationCancelButtonId = 'justificationCancelButtonId';
export const justificationTextboxId = 'justificationTextboxId';
// Demo app test ids
export const justificationDialogButtonId = 'justificationDialogButtonId';
export const errorDialogButtonId = 'errorDialogButtonId';
